import { Activity } from "@mapmycustomers/shared/types/entity";

import { parseApiDateAsNumber } from "@app/util/parsers";

const FALLBACK_SECONDS = 30 * 60;

const durationSecondsFromActivity = (activity: Pick<Activity, "endAt" | "startAt">): number => {
  const start = activity.startAt ? parseApiDateAsNumber(activity.startAt) : NaN;
  const end = activity.endAt ? parseApiDateAsNumber(activity.endAt) : NaN;
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
    return FALLBACK_SECONDS;
  }
  return Math.round((end - start) / 1000);
};

export default durationSecondsFromActivity;
